// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { PricePresentationData } from '../Classes/PricePresentationData';
export class RatesRequestModel {
  salesOfficeIds: number[];
  bookingOfficeId: number;
  business: string;
  segmentId: number;
  division: number;
  cultureId: number;
  subSegmentId: number;
  defaultZineOffice: number;
  defaultEngOffice: number;
  selectedEngOfficeForECS: number;
  selectedDepOfficeForECS: number;
  isOldSapSubmitted: boolean;
  isEcsApplicable: boolean;
  pricePresentationData: PricePresentationData;
  useProjectLeadRate: boolean;
}
